import Constants from "@/widgets/shared/constants";
import dayjs from '@/shared/utils/day';

export function visibleSessions(state, getters) {
  const activeAgendaId = state.agendas.selectedId;
  const activeDayId = state.days.selectedId;

  if (activeAgendaId < 0) {
    const getVisibleSessions = getters["schedule/visibleSessions"];
    return getVisibleSessions(activeDayId);
  } else {
    const getVisibleSessions = getters["sessions/visibleSessions"];
    const visibleSessions = getVisibleSessions(activeAgendaId, activeDayId);
    if (state.theme === Constants.WIDGET_THEME_TYPES.SCIENTIFIC) {
      let shownDays = [];

      visibleSessions.forEach(session => {
        if (!shownDays.includes(session.agenda_session_day.only_date)) {
          session.showDate = true;
          shownDays = [...shownDays, session.agenda_session_day.only_date];
        } else {
          session.showDate = false;
        }
      });
    }
    return visibleSessions;
  }
}

export function filteredSessions(state, getters) {
  const paths = getters["paths/selectedPathIds"];
  const places = getters["places/selectedPlaceIds"];
  let sessions = getters["visibleSessions"];

  if (paths.length > 0) {
    sessions = sessions.filter(session => paths.includes(session.tag_agenda_path.id));
  }
  if (places.length > 0) {
    sessions = sessions.filter(session => places.includes(session.tag_agenda_place.id));
  }
  return sessions;
}

export function visibleMeetings(state, getters) {
  const activeDay = getters["days/activeDay"];
  const activeDayDate = activeDay && activeDay.only_date;
  const getVisibleMeetings = getters["meetings/visibleMeetings"];

  return getVisibleMeetings(activeDayDate);
}

export function filteredSessionsWithMeetings(state, getters) {
  const sessions = wrapCollection(getters["filteredSessions"], "session");
  const meetings = wrapCollection(getters["visibleMeetings"], "meeting");

  // Join and sort collected items
  return [...sessions, ...meetings].sort((a, b) => a.order - b.order);
}

export const searchSessions = (state, getters) => searchQuery => {
  const activeAgendaId = state.agendas.selectedId;
  const sessions = getters["sessions/sessionsByComponent"](activeAgendaId);
  const flattenSessions = sessions.reduce((acc, session) => {
    acc.push(session);
    acc.push(...session.agenda_session_children);
    return acc;
  }, []);
  const filteredSessions = flattenSessions.filter(session => {
    const lowerCaseQuery = searchQuery.toLowerCase();
    if (searchQuery) {
      return (
        lowerCaseQuery &&
        (session.name.toLowerCase().includes(lowerCaseQuery) ||
          (session.description && session.description.toLowerCase().includes(lowerCaseQuery)) ||
          session.speakers.some(speaker => `${speaker.first_name} ${speaker.last_name}`.toLowerCase().includes(lowerCaseQuery)))
      );
    } else {
      return true;
    }
  });
  const sortedSessions = filteredSessions.sort(sessionsSortFunction);
  let shownDays = [];

  sortedSessions.forEach(session => {
    if (!shownDays.includes(session.agenda_session_day.only_date)) {
      session.showDate = true;
      shownDays = [...shownDays, session.agenda_session_day.only_date];
    } else {
      session.showDate = false;
    }
  });
  return sortedSessions;
};

export function showcaseSessions(state, getters) {
  const activeAgendaId = state.agendas.selectedId;
  let sessions = getters["sessions/sessionsByComponent"](activeAgendaId);
  const paths = state.preselectedPathIds;
  const places = state.preselectedPlaceIds;
  const activeDayId = state.preselectedDayId;
  if (paths.length > 0) {
    sessions = sessions.filter(session => paths.includes(session.tag_agenda_path.id));
  }
  if (places.length > 0) {
    sessions = sessions.filter(session => places.includes(session.tag_agenda_place.id));
  }
  if (activeDayId) {
    sessions = sessions.filter(session => session.agenda_session_day.id === activeDayId);
  }
  const sortedSessions = sessions.sort(sessionsSortFunction);

  let shownDays = [];

  sortedSessions.forEach(session => {
    if (!shownDays.includes(session.agenda_session_day.only_date)) {
      session.showDate = true;
      shownDays = [...shownDays, session.agenda_session_day.only_date];
    } else {
      session.showDate = false;
    }
  });
  return wrapCollection(sortedSessions, "session");
}

function wrapCollection(collection, type) {
  return collection.map(value => ({ type, value, order: Date.parse(value.time_start) }));
}

const sessionsSortFunction = (a, b) => {
  if (a.agenda_session_day.only_date !== b.agenda_session_day.only_date) {
    return new dayjs(a.agenda_session_day.only_date) < new dayjs(b.agenda_session_day.only_date) ? -1 : 1;
  } else {
    return new dayjs(a.time_start) < new dayjs(b.time_start) ? -1 : 1;
  }
};
